import { CreateProduct, Product, UpdateProduct } from '@/entities/product';
import { Api } from './api/axios-config';

export class ProductService{
  private static api = Api();

  public static async getAllProduct(): Promise<Product[] | null>{
    const response = await this.api.get<any>('/product');
    if(response.status === 200){
      const products = response.data.map((data:any)=>({
        id:data.id,
        name:data.name,
        price:data.price,
        deploy: data.deploy,
        description:data.description,
        commission: data.commission
      }));
      return products;
    }
    return null;
  }

  public static async getAllModulesByBusiness(businessId: number) {
    const response = await this.api.get<any>(`/product/modules/${businessId}`);
    if(response){
      return response.data;
    }
    return null;
  }

  public static async getAllmodule(): Promise<Product[] | null> {
    const response = await this.api.get<any>('/product/modules');
    if(response.status === 200){
      const products = response.data.map((data:any)=>({
        id:data.id,
        name:data.name,
        price:data.price,
        deploy: data.deploy,
        description:data.description,
        commission: data.commission
      }));
      return products;
    }
    return null;
  }

  public static async createProduct(product: CreateProduct):Promise<Product | null>{
    const response = await this.api.post<any>('/product/create',{
      name:product.name,
      description:product.description,
      price:product.price,
      deploy: product.deploy,
      commission:product.commission,});
    if(response.status === 201){
      return {
        id: response.data.id,
        name:response.data.name,
        description:response.data.description,
        deploy: response.data.deploy,
        price:response.data.price,
        commission:response.data.commission
      };
    }
    return null;
  }

  public static async updateProduct(productId:number,product: UpdateProduct):Promise<Product | null>{
    const response = await this.api.post<any>(`/product/update/${productId}`, {
      name:product.name,
      description:product.description,
      deploy:product.deploy,
      price:product.price,
      commission:product.commission,
    });
    if(response.status === 201){
      return response.data;
    }
    return null;
  }

  public static async deleteProduct(id:number):Promise<Product | null>{
    const response = await this.api.delete<any>(`/product/${id}`);
    if(response.status === 200){
      return{
        id: response.data.id,
        name:response.data.name,
        description:response.data.description,
        deploy:response.data.deploy,
        price:response.data.price,
        commission:response.data.commission
      };
    }
    return null;
  }
}
